import React from "react";
import { Col, Row } from "../../../Grid";
import { textAlignPropTypes } from "../../../props/sx";
import { classes } from "../../../utils/classes";

export const FormFooterCol = ({ textAlign = "center", className = "mt-4 mb-2", ...props }) => {
	return <Col auto className={classes(`text-${textAlign}`, className)} {...props} />;
};

FormFooterCol.propTypes = {
	textAlign: textAlignPropTypes,
	...Col.propTypes,
};

const FormFooter = ({ ...props }) => <Row {...props} />;

FormFooter.propTypes = {
	...Row.propTypes,
};

FormFooter.Col = FormFooterCol;

export default FormFooter;
